export const DATE_DAY_FORMATE = 'YYYY-MM-DD'
export const DATE_MONTH_FORMATE = 'YYYY-MM'
export const DATE_TIME_FORMATE = 'YYYY-MM-DD HH:mm:ss'